<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>A COP’S LIFE</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<h2 class="h2"><a id="page_vii"></a><a id="contents"></a>CONTENTS</h2>
<p class="toc"><a href="#/xhtml/frontmatter02">Preface: The Commendation</a></p>
<p class="linespace"> </p>
<p class="toc"><a href="#/xhtml/chapter01">Johnny’s Last Day</a></p>
<p class="toc"><span href="#/xhtml/chapter02" title="Link target outside of Sample">Sunday Mourning</span></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample">405</span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Graveyard</span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample">Juvenile</span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Dead Man Talking</span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample">Shadow of the Executioner</span></p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample">The Journey</span></p>
<p class="toc"><span href="#/xhtml/chapter09" title="Link target outside of Sample">Her Name Was Jackie</span></p>
<p class="toc"><span href="#/xhtml/chapter10" title="Link target outside of Sample">The Ultimate Ninja Warrior</span></p>
<p class="toc"><span href="#/xhtml/chapter11" title="Link target outside of Sample">The Man of the House</span></p>
<p class="toc"><span href="#/xhtml/chapter12" title="Link target outside of Sample">Domestic</span></p>
<p class="toc"><span href="#/xhtml/chapter13" title="Link target outside of Sample">Honor Thy Mother</span></p>
<p class="toc"><span href="#/xhtml/chapter14" title="Link target outside of Sample">My Child</span></p>
<p class="toc"><span href="#/xhtml/chapter15" title="Link target outside of Sample">The Honor Student</span></p>
<p class="toc"><span href="#/xhtml/chapter16" title="Link target outside of Sample">Death Dance</span></p>
<p class="toc"><span href="#/xhtml/chapter17" title="Link target outside of Sample">The 3:00 <span class="smallcaps">A.M.</span> Phone Call</span><a id="page_viii"></a></p>
<p class="toc"><span href="#/xhtml/chapter18" title="Link target outside of Sample">Willy</span></p>
<p class="toc"><span href="#/xhtml/chapter19" title="Link target outside of Sample">The Messenger</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?76268233